import { render, staticRenderFns } from "./InspectionStatusIndicatorBadge.vue?vue&type=template&id=066673b1&scoped=true"
import script from "./InspectionStatusIndicatorBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionStatusIndicatorBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionStatusIndicatorBadge.vue?vue&type=style&index=0&id=066673b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066673b1",
  null
  
)

export default component.exports